export { entity_add_comment } from '../../systemCommands/entitySystem/entity_add_comment';
